/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuButton, NeuInput } from '@neutron/react';

interface IEncountersHistoryTabsProps {
  background?: string;
  justify?: string;
  shadow?: boolean;
}

export const UsersListContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100vh - 128px);
`;

export const TemplatesTreeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0.625em 1em;
  width: 100%;
`;

export const HeaderItemsContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  height: fit-content;
`;

export const TemplatesTreeBtnContainer = styled.div`
  flex: 1;
`;

export const StyledTemplateBtn = styled(NeuButton)`
  > button {
    font-size: 1rem;
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }
`;

export const QuestionBankContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 128px);
`;

export const EncountersContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100vh - 128px);
`;

export const DischargesContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 128px);
`;

export const EncountersSidePanelContainer = styled.div`
  flex-basis: 25%;
  max-width: 16em;
  background-color: white;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.25);
  padding: 15px;
  overflow: scroll;
  z-index: 5;
  ::-webkit-scrollbar {
    width: 2px;
  }
  ::-webkit-scrollbar-thumb {
    background: rgb(224, 224, 224);
    border-radius: 10px;
  }
`;

export const EncountersSidePanelSubheader = styled.p`
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: #686868;
  margin-bottom: 10px;
`;

export const EncounterSidePanelInput = styled(NeuInput)`
  margin-top: 5px;
  margin-bottom: 10px;
`;

export const EncounterSidePanelInputLabels = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
`;

export const EncountersHistoryTabs = styled.div<IEncountersHistoryTabsProps>`
  display: flex;
  flex-direction: row;
  background: ${({ background }) => background || 'transparent'};
  width: 100%;
  height: 60px;
  box-shadow: ${({ shadow }) =>
    shadow ? '0px 2px 4px rgba(25, 25, 25, 0.2)' : 'none'};
`;

export const EncounterHistorySidePanelLabels = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0px;
  text-align: left;
`;

export const EncounterHistorySidePanelData = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0px;
  text-align: left;
  margin-top: 5px;
  margin-bottom: 20px;
`;

export const EncountersTableContainer = styled.div`
  width: 100%;
`;

export const AreasContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100vh - 128px);
`;

export const TemplatesContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100vh - 128px);
`;

export const AreasContainerInner = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const BackText = styled.p`
  display: flex !important;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  text-align: left;
  color: var(--primary-60);
  margin-bottom: 1rem !important;
  display: flex;
  align-items: center;
  :hover {
    cursor: pointer;
  }
`;

export const EncountersHistoryTableContainer = styled.div`
  margin-top: 5px;
  overflow-y: scroll;
  overflow-x: scroll;
  scroll-behavior: smooth;

  ::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }
  ::-webkit-scrollbar-thumb {
    background: rgb(224, 224, 224);
    border-radius: 10px;
  }
`;

export const JsonViewContainer = styled.div`
  padding-left: 15px;
  padding-right: 15px;
`;

export const JsonView = styled.div`
  background: white;
  padding: 20px;
  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);
  border-radius: 5px;
`;
